(function (ng) {
  //component definition for the "Return Initiated" page
  ng.module("evo.returns.initiate.components").component(
    "returnAuthorizationSubmittedPage",
    {
      templateUrl: [
        "TEMPLATES_BASE",
        function (TEMPLATES_BASE) {
          return (
            TEMPLATES_BASE +
            "returns/initiate/components/returnAuthorizationSubmittedPage"
          );
        },
      ],
      bindings: {
        createResponse: "<",
      },
      controller: [
        "RETURNS_BASE",
        function (RETURNS_BASE) {
          var ctrl = this;

          //create the print url based on the label's information
          ctrl.createPrintLabelUrl = function () {
            var label = ctrl.createResponse.Label;

            return (
              RETURNS_BASE +
              "label/" +
              label.LabelType +
              "/" +
              label.ImageFileName
            );
          };

          ctrl.$onInit = function () {
            if (!ctrl.createResponse.ReturnAuthorizationId) {
              $state.go("initiate.initiateReturnPage");
            }

            dataLayerManager.pushEvoPageType(
              "post purchase (submitted return)"
            );
          };
        },
      ],
    }
  );
})(angular);
